// Footer.jsx
import React from "react";
import "./Footer.css";

export default function Footer({ onOpenContact }) {
  return (
    <footer className="footer-container">
      <div className="footer-content">
        <div className="footer-section">
          <h3>About Us</h3>
          <p>Professional painting and construction services in Roanoke, VA and surrounding areas, delivering quality and excellence in every project.</p>
        </div>
        
        <div className="footer-section">
          <h3>Contact Info</h3>
          <p>
            <i className="fas fa-map-marker-alt"></i> Roanoke, VA
          </p>
          <p>
            <i className="fas fa-phone"></i> 540-985-1728
          </p>
          <p>
            <i className="fas fa-envelope"></i> paintingarely@gmail.com
          </p>
        </div>

        <div className="footer-section">
          <h3>Connect With Us</h3>
          <div className="social-links">
            <a 
              href="https://www.instagram.com/arely.painting.llc"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
            >
              <i className="fab fa-instagram"></i>
              Follow us on Instagram
            </a>
            <button onClick={onOpenContact} className="contact-button">
              <i className="fas fa-envelope"></i>
              Contact Us
            </button>
          </div>
        </div>
      </div>
      
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} ARELY CONSTRUCTION & PAINTING LLC. All rights reserved.</p>
      </div>
    </footer>
  );
}